export const common = {
  nav: {
    home: 'HOME',
    registration: 'REGISTRATION',
    regulations: 'REGULATIONS',
    registerNow: 'REGISTER NOW',
  },
  hero: {
    title: 'SINJAVINA SKYRACE 2026',
    date: 'JUNE 6, 2026',
    location: 'MOJKOVAC, MONTENEGRO',
    description: 'Experience the ultimate mountain running challenge in the heart of Montenegro\'s pristine wilderness',
    cta: 'REGISTER NOW',
  },
  races: {
    title: 'CHOOSE YOUR CHALLENGE',
    skyrace: {
      badge: 'ULTRA',
      title: 'SINJAVINA SKYRACE',
      distance: 'Distance: 40km',
      elevation: 'Elevation: 2000m D+',
      timeLimit: 'Time Limit: 8 hours',
      maxAltitude: 'Max Altitude: 1863m',
      description: 'The ultimate skyrunning challenge through Sinjavina plateau, crossing mountain passes, traditional katuns, and finishing in Mojkovac town square.',
      button: 'REGISTER - SKYRACE',
    },
    miniSkyrace: {
      badge: 'SHORT',
      title: 'SINJAVINA MINI SKYRACE',
      distance: 'Distance: 10km',
      elevation: 'Elevation: 1000m D+',
      timeLimit: 'Time Limit: 3 hours',
      maxAltitude: 'Max Altitude: 1734m',
      description: 'Perfect introduction to mountain racing, finishing at the stunning Zabojsko Lake. Ideal for first-timers and those seeking a shorter challenge.',
      button: 'REGISTER - MINI SKYRACE',
    },
  },
  highlights: {
    title: 'WHY SINJAVINA SKYRACE',
    nature: {
      title: 'PRISTINE NATURE',
      description: 'Run through untouched mountain landscapes, traditional shepherd settlements, and crystal-clear mountain lakes',
    },
    experience: {
      title: 'AUTHENTIC EXPERIENCE',
      description: 'Experience genuine Montenegrin mountain culture with local support, traditional food, and warm hospitality',
    },
    organization: {
      title: 'PROFESSIONAL ORGANIZATION',
      description: 'Well-marked trails, multiple aid stations, safety support, and experienced mountain race organization',
    },
  },
  tracks: {
    title: 'RACE TRACKS',
    description: 'Download the official GPS tracks for both race distances',
    button: 'DOWNLOAD TRACKS',
  },
  location: {
    title: 'RACE LOCATION',
    startPoint: 'START POINT: HOTEL RAVNJAK',
    address: 'SELO BISTRICA, MOJKOVAC',
    coordinates: '42.989524, 19.410788',
    description: 'Located in the heart of Montenegro\'s mountain region, easily accessible from Podgorica (90km) and surrounded by breathtaking natural beauty',
  },
  footer: {
    tagline: 'Montenegro\'s Premier Mountain Race',
    quickLinks: 'QUICK LINKS',
    contact: 'CONTACT',
    email: 'Email',
    phone: 'Phone',
    locationLabel: 'Location',
    copyright: '© 2026 Sinjavina Skyrace. All rights reserved.',
    poweredBy: 'Powered by AvaiBookSports.com',
  },
};